import _ from 'lodash';
import React, { useRef } from 'react';
import { Form } from 'src/@vymo/ui/molecules';
import { FormVersion } from 'src/@vymo/ui/molecules/form/types';
import styles from '../index.module.scss';

function ProfileInputs(props) {
  const { inputs, formValues } = props;
  const formRef = useRef(null);
  return (
    <Form
      ref={formRef}
      id="profileCardForm"
      name="profileCardForm"
      span="1fr"
      className={styles.detailsWrapper__profileCard__profileInputs}
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onChange={(formFields) => {}}
      config={{
        version: FormVersion.webRevyre,
        data: inputs.map((input) => _.omit(input, ['value'])),
        grouping: [],
        fieldItemConfig: {
          showDisabledIcon: true,
        },
        viewMode: true,
      }}
      value={formValues}
    />
  );
}

export default ProfileInputs;
